import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Skeleton from '@material-ui/lab/Skeleton';
import { AvatarGroup } from '@material-ui/lab';
import { Box, CardActions } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    height: 375,
    maxWidth: 310,
    minWidth: 290,
  },
  media: {
    height: 190,
  },
}));

export const MeetingPreload = (props) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          content: classes.cardHeaderContent,
        }}
        avatar={
          <Skeleton animation='wave' variant='circle' width={40} height={40} />
        }
        subheader={<Skeleton animation='wave' height={10} width='80%' />}
      >
        <Skeleton animation='wave' height={10} width='80%' />
      </CardHeader>
      <Skeleton animation='wave' variant='rect' className={classes.media} />
      <CardContent>
        <Skeleton animation='wave' height={10} width='100%' />
      </CardContent>
      <CardActions position='static'>
        <Box display='flex' flexGrow={1}>
          <Skeleton animation='wave' height={50} width='40%' />
        </Box>
        <AvatarGroup max={3}>
          <Skeleton animation='wave' variant='circle' width={40} height={40} />
          <Skeleton animation='wave' variant='circle' width={40} height={40} />
          <Skeleton animation='wave' variant='circle' width={40} height={40} />
        </AvatarGroup>
      </CardActions>
    </Card>
  );
};
